var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"gifsScroll",staticClass:"panel-scroll gif-panel"},[_c('div',{staticClass:"panel-body"},[_c('h6',{staticClass:"mb-3"},[_vm._v("Add Texts")]),_vm._l((_vm.texts),function(text){return _c('div',{key:text.fontFamily,staticClass:"mb-3 text-container"},[_c('span',{style:({
          fontFamily: text.fontFamily,
          fontSize: text.fontSize,
          lineHeight: text.lineHeight,
          letterSpacing: text.letterSpacing,
        }),on:{"click":function($event){return _vm.handleAddText(text)}}},[_vm._v(_vm._s(text.name))])])})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }